import ConfirmModalManager from './ConfirmModalManager';

export default ConfirmModalManager;
export { ConfirmModalManager };
